export default __webpack_public_path__ + "static/media/amazon.c0c2df4a.svg";